import Vue from 'vue'
import { app, data } from './config/selectors'
import App from './App.vue'
import { captureMessage } from '@sentry/browser'

import './main.entry.css'

const initApp = () => {
  const mountEl = document.querySelector(app.appMountEl)

  if (!mountEl) return

  const displayId = mountEl.getAttribute(data.displayId)

  if (!displayId) {
    captureMessage('Display ID not found')
    return
  }

  new Vue({
    render: h => h(App, {
      props: {
        displayId: displayId
      }
    })
  }).$mount(mountEl)
}

initApp()
